//@ts-nocheck
import React, {
  FC,
  forwardRef,
  InputHTMLAttributes,
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from 'react'
import {useFormik} from 'formik'
import {useIntl} from 'react-intl'
import clsx from 'clsx'
import Swal from 'sweetalert2'
import {useMutation, useQuery, useQueryClient} from 'react-query'
import {Link, useSearchParams} from 'react-router-dom'
import {Dropdown, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {
  formatDateToISO,
  ID,
  isNotEmpty,
  KTSVG,
  QUERIES,
  TaskSprint,
  toAbsoluteUrl,
} from '../../../../../../_metronic/helpers'
import {Task, ResponseTask, taskPriorityOptions} from '../core/_models'
import {useListView} from '../core/ListViewProvider'
import {Loading} from '../../../../../../_metronic/partials/components/loading/Loading'
import {
  deleteTaskInSprint,
  playTimeTracking,
  stopTimeTracking,
  updateTask,
  getUsersByTaskId,
  updateStatusTask,
  updateNameTask,
} from '../core/_requests'
import {useQueryResponse} from '../core/QueryResponseProvider'
import {getProjectsTask} from '../../core/_requests'
import {Project} from '../../core/_models'
import {useAuth, UserModel} from '../../../../auth'
import {Toast} from '../../../../../../_metronic/partials/widgets'
import {CustomToggleProps} from '../table/columns/TaskActionsCell'
import {deleteTask} from '../core/_requests'
import {deliveryTask, deliveryTaskPartial, reopenTaskMyPart} from '../core/_requests'
import {OverviewAttachement} from '../TaskAttachment/OverviewAttachment'
import {TaskChecklistEditor} from '../TaskChecklist/TaskChecklistEditor'
import {UsersSymbolGroupColumn} from '../UsersSymbolGroupColumn'
import {AdjustTimeUserModal} from '../../../../../../_metronic/partials/modals/adjust-time-user/AdjustTimeUserModal'
import {DeliveryOptionsModal} from '../../../../../../_metronic/partials/modals/task-delivery/DeliveryOptionsModal'
import {SelectAutoComplete} from '../../../../../../_metronic/partials/components/Select/SelectAutoComplete'
import {CreateProjectAndClient} from '../../../../../../_metronic/partials/modals/create-project-and-client/CreateProjectAndClientModal'
import {getChecklistClone} from '../TaskChecklist/core/_requests'
import {TaskComments} from './components/TaskComents/TaskComments'
import {Tag} from '../../../../../../_metronic/partials/modals/task/core/_models'
import {TagsAutoComplete} from '../../../../../../_metronic/partials/modals/task/components/TagsAutoComplete'
import {TaskSequenceResponsibles} from './TaskSequenceResponsibles'
import CreatableSelect from 'react-select/creatable'
import Select from 'react-select'
import {salesforceApiService, SalesforceCatalogItem} from '../../../../integrations/services/salesforceApi'
import SourceEditingEditor from 'ckeditor5-build-classic-source-editing'
import {CKEditor} from '@ckeditor/ckeditor5-react'
import StripColorsOnPaste from '../../../../../../_metronic/partials/components/rich-text-edit/plugins/StripColorsOnPaste'
import {error} from 'console'
import {Subtasks} from './Subtasks'
import dayjs from 'dayjs'
import {TaskRecurrence} from '../../../../../../_metronic/partials/modals/task/components/TaskRecurrence'
import {useCanDeleteTask} from '../../../../config/hooks/useCanDeleteTask'
import {useCanEditTaskDescription} from '../../../../config/hooks/useCanEditTaskDescription'
import {TaskDateTimeFields} from '../../../../../../_metronic/helpers/TaskDateTimeFields'
import {isValidTaskDateTimeRange, toDatePickerValue} from '../../../../../../_metronic/helpers/TaskDateTime'
import {invalidateAfterTaskChange} from '../../../../../../_metronic/helpers/taskQueryInvalidation'

type Props = {
  isTaskLoading: boolean
  task: ResponseTask
  handleClose: () => void | undefined
  handleForceClose?: () => void | undefined
}
interface responsibeProps extends InputHTMLAttributes<HTMLInputElement> {
  image: string
  name: string
}

interface checkProps extends InputHTMLAttributes<HTMLInputElement> {
  content: string
  check: boolean
}

// Theme-aware react-select styles for the Tipo/Serviço/Subserviço (Salesforce) selects.
// classNames alone left the option hover state using react-select's default light
// background, which is nearly unreadable against dark-theme text — these inline styles
// use CSS variables plus a translucent color overlay so contrast holds in both themes.
const salesforceSelectStyles = {
  menu: (styles: any) => ({
    ...styles,
    backgroundColor: 'var(--bs-body-bg)',
    color: 'var(--bs-body-color)',
  }),
  option: (styles: any, {isFocused, isSelected}: any) => ({
    ...styles,
    backgroundColor: isSelected
      ? 'rgba(54, 155, 255, 0.35)'
      : isFocused
        ? 'rgba(54, 155, 255, 0.2)'
        : 'transparent',
    color: 'var(--bs-body-color)',
  }),
  singleValue: (styles: any) => ({...styles, color: 'var(--bs-body-color)'}),
  input: (styles: any) => ({...styles, color: 'var(--bs-body-color)'}),
  placeholder: (styles: any) => ({...styles, color: 'var(--bs-gray-600)'}),
}

const TaskEditModalForm: FC<Props> = ({task, isTaskLoading, handleClose, handleForceClose}) => {
  const intl = useIntl()
  const {setItemIdForUpdate} = useListView()
  const {refetch} = useQueryResponse()
  const [data, setData] = useState<Task>(task?.tasks)
  const [selectedOptions, setSelectedOptions] = useState(data.tags)
  const queryClient = useQueryClient()
  const [selectedResponsibleId, setSelectedResponsibleId] = useState<number>()
  const {canDelete} = useCanDeleteTask({ creator_id: task?.tasks?.creator_id })
  const {canEditDescription} = useCanEditTaskDescription({creator_id: task?.tasks?.creator_id})

  const [responsible, setResponsible] = useState<Array<responsibeProps>>([])
  const {currentUser, setCurrentUser, auth} = useAuth()
  const [isSubmitting, setSubmitting] = useState<boolean>(false)
  const [clients, setClients] = useState<Project[]>([])
  var today = new Date().toISOString().split('T')[0]

  const [statustask, setStatusTask] = useState(task?.tasks.status)
  const [time, setTime] = useState(task?.tasks.total_time!)
  const [play, setPlay] = useState(task?.tasks.play)
  const countRef = useRef()
  const [stopwatch, setStopwatch] = useState(0)
  const sequenceResponsibles = task?.tasks?.sequence_responsibles ?? []
  const users = (task?.tasks?.users ?? []) as Array<{
    user_id?: number
    id?: number
    task_concluded?: number
    pivot?: {concluded?: number}
  }>
  const hasSequence = sequenceResponsibles.length > 0
  const myPartConcluded =
    !hasSequence &&
    statustask?.toLowerCase() !== 'entregue' &&
    !!currentUser?.id &&
    users.some(
      (u) =>
        Number(u.user_id ?? u.id) === Number(currentUser.id) &&
        Number(u.task_concluded ?? u.pivot?.concluded ?? 0) === 1
    )

  const [showAdjustTimeModal, setShowAdjustTimeModal] = useState<boolean>(false)
  const [showDeliveryModal, setShowDeliveryModal] = useState<boolean>(false)
  const [showProjectAndClientModal, setShowProjectAndClientModal] = useState<boolean>(false)
  const [tasks, setTasks] = useState<Array<TaskSprint>>([])
  const TemaAtual = window.localStorage.getItem('kt_theme_mode_value') || ''
  const [checks, setChecks] = useState<Array<checkProps>>([])
  const [name_input, setNameInput] = useState<string>(data.name?.toString() || '')
  const initialNameRef = useRef<string>(task?.tasks.name?.toString() || '')
  const [isNameDirty, setIsNameDirty] = useState<boolean>(false)
  const [description_input, setDescriptionInput] = useState<string>(
    data.description?.toString() || ''
  )
  const [delivery_date_input, setDeliveryDateInput] = useState<string>(data.expected_date ?? '')
  const [searchParams, setSearchParams] = useSearchParams()
  const sprintId = searchParams.get('sprintId')
  // Track dirty state only for specific tabs: 1) description, 3) checklist, 6) responsible sequence
  const initialDescriptionRef = useRef<string>(task?.tasks.description || '')
  const initialResponsiblesRef = useRef<any[]>(
    JSON.parse(JSON.stringify(task?.tasks.sequence_responsibles || []))
  )
  const [isDescriptionDirty, setIsDescriptionDirty] = useState<boolean>(false)
  const [isChecklistDirty, setIsChecklistDirty] = useState<boolean>(false)
  const [isResponsiblesDirty, setIsResponsiblesDirty] = useState<boolean>(false)
  const [isRightPanelDirty, setIsRightPanelDirty] = useState<boolean>(false)
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [saveStatus, setSaveStatus] = useState<'idle' | 'saving' | 'saved' | 'error'>('idle')
  const saveTimeoutRef = useRef<NodeJS.Timeout | null>(null)
  const checklistDebounceRef = useRef<NodeJS.Timeout | null>(null)
  const autoSaveDebounceRef = useRef<NodeJS.Timeout | null>(null)

  const tabIds = useMemo(() => {
    const prefix = `task-edit-${Math.random().toString(36).slice(2, 10)}`
    return {
      description: `${prefix}-description`,
      attachments: `${prefix}-attachments`,
      checklist: `${prefix}-checklist`,
      comments: `${prefix}-comments`,
      subtasks: `${prefix}-subtasks`,
      responsibleSequence: `${prefix}-responsible-sequence`,
    }
  }, [])

  type RightPanelSnapshot = {
    begin_date: string | null
    expected_date: string | null
    priority: string | null
    project_id: number | string | null | undefined
    tagsKey: string
    recurrenceKey: string
  }
  const buildTagsKey = (opts: any[]): string => {
    try {
      const arr = Array.isArray(opts) ? opts : []
      // Normalize to string, ignore order by sorting by value/label
      const mapped = arr.map((o: any) => ({
        value: o?.value ?? o?.id ?? o?.name ?? '',
        label: o?.label ?? o?.name ?? '',
      }))
      mapped.sort(
        (a, b) =>
          String(a.value).localeCompare(String(b.value)) ||
          String(a.label).localeCompare(String(b.label))
      )
      return JSON.stringify(mapped)
    } catch (_) {
      return '[]'
    }
  }

  const normalizeRecurrenceData = (recurrence: any): any => {
    if (!recurrence) return null

    try {
      return {
        frequency: recurrence.frequency || null,
        endType: recurrence.endType || recurrence.recurrence_type || 'never',
        repeatCount: recurrence.repeatCount ?? recurrence.repeat_count ?? null,
        endDate: recurrence.endDate || recurrence.end_date || null,
        selectedWeekdays: recurrence.selectedWeekdays || recurrence.weekdays || [],
        ruleType: recurrence.ruleType || recurrence.rule_type || null,
        ruleDays: recurrence.ruleDays || recurrence.rule_days || null,
        replicationRelations:
          recurrence.replicationRelations || recurrence.replication_relations || [],
        replicateOnDelivered:
          recurrence.replicateOnDelivered ?? recurrence.replicate_on_delivered ?? false,
      }
    } catch (_) {
      return null
    }
  }

  const buildRecurrenceKey = (recurrence: any): string => {
    try {
      if (!recurrence) return 'null'
      const normalized = normalizeRecurrenceData(recurrence)
      return JSON.stringify({
        frequency: normalized.frequency || null,
        endType: normalized.endType || null,
        repeatCount: normalized.repeatCount || null,
        endDate: normalized.endDate || null,
        selectedWeekdays: normalized.selectedWeekdays || [],
        ruleType: normalized.ruleType || null,
        ruleDays: normalized.ruleDays || null,
        replicationRelations: normalized.replicationRelations || [],
        replicateOnDelivered: normalized.replicateOnDelivered || false,
      })
    } catch (_) {
      return 'null'
    }
  }
  const initialRightPanelRef = useRef<RightPanelSnapshot>({
    begin_date:
      task?.tasks.begin_date && task?.tasks.begin_date.trim() !== ''
        ? task?.tasks.begin_date
        : null,
    expected_date:
      task?.tasks.expected_date && task?.tasks.expected_date.trim() !== ''
        ? task?.tasks.expected_date
        : null,
    priority: task?.tasks.priority || null,
    project_id: task?.tasks.project_id,
    tagsKey: buildTagsKey(selectedOptions),
    recurrenceKey: buildRecurrenceKey(task?.tasks.recurrence || null),
  })

  const computeRightPanelDirty = (overrides: Partial<RightPanelSnapshot> = {}) => {
    const snap = initialRightPanelRef.current
    const now: RightPanelSnapshot = {
      begin_date:
        overrides.begin_date !== undefined
          ? overrides.begin_date
          : formik.values.begin_date ?? null,
      expected_date:
        overrides.expected_date !== undefined
          ? overrides.expected_date
          : formik.values.expected_date ?? null,
      priority:
        overrides.priority !== undefined ? overrides.priority : formik.values.priority ?? null,
      project_id:
        overrides.project_id !== undefined
          ? overrides.project_id
          : formik.values.project_id ?? null,
      tagsKey: overrides.tagsKey !== undefined ? overrides.tagsKey : buildTagsKey(selectedOptions),
      recurrenceKey:
        overrides.recurrenceKey !== undefined
          ? overrides.recurrenceKey
          : buildRecurrenceKey(formik.values.recurrence),
    }
    setIsRightPanelDirty(
      snap.begin_date !== now.begin_date ||
        snap.expected_date !== now.expected_date ||
        String(snap.priority || '') !== String(now.priority || '') ||
        String(snap.project_id || '') !== String(now.project_id || '') ||
        snap.tagsKey !== now.tagsKey ||
        snap.recurrenceKey !== now.recurrenceKey
    )
  }

  // Keep an initial snapshot of checklist to compare changes against
  const initialChecksRef = useRef<Array<{content: string; check: boolean} | null> | null>(null)

  const normalizeChecks = (arr: Array<checkProps>): Array<{content: string; check: boolean}> => {
    return (arr || []).map((item) => ({
      content: (item.content || '').toString().trim(),
      check: Boolean(item.check),
    }))
  }

  const areChecksEqual = (
    a: Array<{content: string; check: boolean}> | null,
    b: Array<{content: string; check: boolean}> | null
  ): boolean => {
    if (!a || !b) return false
    if (a.length !== b.length) return false
    for (let i = 0; i < a.length; i++) {
      if (a[i].content !== b[i].content || a[i].check !== b[i].check) return false
    }
    return true
  }

  // Atualizar data quando a tarefa for carregada
  useEffect(() => {
    if (task?.tasks) {
      setData(task.tasks)
    }
  }, [task?.tasks])

  useEffect(() => {
    if (!task?.tasks) return

    setStatusTask(task.tasks.status)
    setPlay(task.tasks.play)
    setTime(task.tasks.total_time ?? 0)
  }, [task?.tasks?.status, task?.tasks?.play, task?.tasks?.total_time, task?.tasks?.id])

  const getSelectClients = useMutation(() => getProjectsTask(parseInt(task?.tasks.project_id!)), {
    onSuccess: (response) => {
      setClients(response.data)
    },
  })

  useEffect(() => {
    getSelectClients.mutateAsync()
    getChecklistCost.mutateAsync()
  }, [])

  useEffect(() => {
    if (task?.tasks.sequence_responsibles) {
      const normalizedSequence = task.tasks.sequence_responsibles.map((responsible: any) => {
        const {task_expected_date, ...rest} = responsible
        return {
          ...rest,
          expected_date: responsible?.expected_date ?? task_expected_date ?? null,
        }
      })
      formik.setFieldValue('sequence_responsibles', normalizedSequence)
      formik.setFieldValue('users', normalizedSequence)
    }
  }, [task?.tasks.sequence_responsibles])

  useEffect(() => {
    if (play === 'run') {
      const newTime = task?.tasks.total_time > time ? task?.tasks.total_time : time + 1
      const intervalId = window.setInterval(() => setTime(newTime), 1000)
      return () => window.clearInterval(intervalId)
    } else {
      setStopwatch(time)
    }

    return () => clearInterval(countRef.current)
  }, [play, time, task?.tasks.total_time])

  const updateData = (fieldsToUpdate: Partial<Task>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    setData(updatedData)
  }

  const addResponsible = (user: string) => {
    setResponsible([...responsible, {image: '', name: user}])
  }

  const getChecklistCost = useMutation(() => getChecklistClone(task?.tasks.id), {
    onSuccess: (response) => {
      // Remover duplicações que podem vir do backend
      const rawData = response.data || []
      // Remover logs para debugging
      // console.log('getChecklistCost - response.data (raw):', rawData)

      // Aplicar múltiplas estratégias de deduplicação

      // Estratégia 1: Remover por ID se existir
      let deduplicated = rawData
      if (rawData.length > 0 && rawData[0].id) {
        const seenIds = new Set()
        deduplicated = rawData.filter((item: any) => {
          if (seenIds.has(item.id)) {
            return false
          }
          seenIds.add(item.id)
          return true
        })
      }

      // Estratégia 2: Remover por conteúdo similar
      const uniqueChecks = deduplicated.filter((item: any, index: number, self: any[]) => {
        return (
          index ===
          self.findIndex((t: any) => {
            // Comparar conteúdo normalizado
            const itemContent = (item.content || '').toString().trim().toLowerCase()
            const tContent = (t.content || '').toString().trim().toLowerCase()

            // Se ambos estão vazios, considerar duplicados apenas se for o primeiro
            if (!itemContent && !tContent) {
              return true
            }

            // Comparar conteúdo e status
            return itemContent === tContent && Boolean(t.check) === Boolean(item.check)
          })
        )
      })

      // Se ainda houver muitos itens vazios, remover extras
      const emptyItems = uniqueChecks.filter((item) => !(item.content || '').toString().trim())
      let finalChecks = uniqueChecks

      if (emptyItems.length > 1) {
        // Manter apenas o primeiro item vazio
        const nonEmptyItems = uniqueChecks.filter((item) => (item.content || '').toString().trim())
        finalChecks = [...nonEmptyItems, emptyItems[0]]
      }

      setChecks(finalChecks)
      // Initialize baseline snapshot on first load
      if (initialChecksRef.current === null) {
        initialChecksRef.current = normalizeChecks(finalChecks)
      }
    },
  })

  const handleChecklistChange = (newChecks: Array<checkProps>) => {
    setChecks(newChecks)
    const current = normalizeChecks(newChecks)
    const baseline = initialChecksRef.current
    setIsChecklistDirty(!areChecksEqual(baseline, current))
  }

  const closeModal = () => {
    clearQueryParams()
    ;(handleForceClose || handleClose)()
  }

  function clearQueryParams() {
    const paramName = 'taskId'
    const url = new URL(window.location.href)
    url.searchParams.delete(paramName)
    const newUrl = url.search ? url.href : url.href.replace('?', '')
    window.history.replaceState({}, document.title, newUrl)
  }

  const {
    isLoading,
    data: dataUsers,
    error,
  } = useQuery(
    `${QUERIES.TASKS_LIST}-${task?.tasks.id}-users`,
    () => {
      return getUsersByTaskId(task?.tasks.id)
    },
    {
      enabled: !!task?.tasks.id,
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  )

  const isSalesforceTask = !!task?.tasks.salesforce_task_id

  const {data: salesforceCatalog = []} = useQuery<SalesforceCatalogItem[]>(
    'salesforce-catalog',
    () => salesforceApiService.getCatalog(),
    {
      enabled: isSalesforceTask,
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  )

  const initialCatalogItem = salesforceCatalog.find(
    (item) => Number(item.id) === Number(task?.tasks.salesforce_catalog_id)
  )
  const [selectedType, setSelectedType] = useState<string | null>(
    initialCatalogItem?.type ?? null
  )
  const [selectedService, setSelectedService] = useState<string | null>(
    initialCatalogItem?.service ?? null
  )

  useEffect(() => {
    if (initialCatalogItem && !selectedType) {
      setSelectedType(initialCatalogItem.type)
      setSelectedService(initialCatalogItem.service)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesforceCatalog])

  const typeOptions = Array.from(new Set(salesforceCatalog.map((i) => i.type))).map((v) => ({
    label: v,
    value: v,
  }))
  const serviceOptions = Array.from(
    new Set(
      salesforceCatalog.filter((i) => i.type === selectedType).map((i) => i.service)
    )
  ).map((v) => ({label: v, value: v}))
  const subserviceOptions = salesforceCatalog
    .filter((i) => i.type === selectedType && i.service === selectedService)
    .map((i) => ({label: i.subservice, value: i.id}))

  const deleta = async () => {
    if (!canDelete) {
      const CurrentTheme = window.localStorage.getItem('kt_theme_mode_value') || ''
      const tema = CurrentTheme === 'dark' ? '#353b48' : '#fff'
      Swal.fire({
        title: 'Acesso negado',
        html: 'Apenas gestores e administradores podem excluir tarefas.',
        icon: 'error',
        background: tema,
        showCloseButton: true,
        confirmButtonText: 'Entendi',
      })
      return
    }

    const CurrentTheme = window.localStorage.getItem('kt_theme_mode_value') || ''
    let tema = ''
    if (CurrentTheme === 'dark') {
      tema = '#353b48'
    } else {
      tema = '#fff'
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    })

    swalWithBootstrapButtons
      .fire({
        title: 'Você tem certeza?',
        html: 'Tem certeza de que deseja deletar essa tarefa? Atenção: se houver horas lançadas ou outras pessoas vinculadas a ela, isso pode impactar o controle de tempo e os custos do projeto.',
        icon: 'warning',
        background: tema,
        showCancelButton: true,
        confirmButtonText: 'Sim, pode excluir',
        cancelButtonText: 'Não, cancele!',
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          return await deleteItem.mutateAsync()
        }
      })
  }

  const deletaTaskInSprint = async () => {
    const CurrentTheme = window.localStorage.getItem('kt_theme_mode_value') || ''
    let tema = ''
    if (CurrentTheme === 'dark') {
      tema = '#353b48'
    } else {
      tema = '#fff'
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    })

    swalWithBootstrapButtons
      .fire({
        title: 'Você tem certeza?',
        html: intl.formatMessage({id: 'ALERT.LABEL.IT_CAN_NOT_BE_UNDONE'}),
        icon: 'warning',
        background: tema,
        showCancelButton: true,
        confirmButtonText: 'Sim, pode desvincular!',
        cancelButtonText: 'Não, cancele!',
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          return await deleteItemTaskInSprint.mutateAsync()
        }
      })
  }

  const hours = Math.floor(time / 3600)
  const minutes = Math.floor((time % 3600) / 60)
  const seconds = time % 60

  const startAndStop = () => {
    if (play === 'pause') {
      playItem.mutateAsync()
    } else {
      stopItem.mutateAsync()
    }
  }

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
      invalidateAfterTaskChange(queryClient)
    }
    setItemIdForUpdate(undefined)
  }

  const entregatask = async () => {
    const sequenceResponsibles = task?.tasks?.sequence_responsibles ?? []
    const users = task?.tasks?.users ?? []
    const responsiblesCount = Array.isArray(users) ? users.length : 0

    if (sequenceResponsibles.length > 0) {
      const CurrentTheme = window.localStorage.getItem('kt_theme_mode_value') || ''
      const tema = CurrentTheme === 'dark' ? '#353b48' : '#fff'
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
        buttonsStyling: false,
      })
      swalWithBootstrapButtons
        .fire({
          title: intl.formatMessage({id: 'ALERT.TITLE.TASK.DELIVERY'}),
          icon: 'warning',
          text: 'Esta tarefa possui outros membros na sequência. Ao entregar, ela será transferida para o próximo responsável. Deseja entregar sua parte?',
          background: tema,
          showCancelButton: true,
          confirmButtonText: 'Sim, entregar minha parte',
          cancelButtonText: 'Não',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) deliveryItem.mutate()
          else if (result.dismiss === Swal.DismissReason.cancel) {
            Toast.fire({
              icon: 'warning',
              title: intl.formatMessage(
                {id: 'ALERT.LABEL.ERROR_TASK_CLOSE_ITEM'},
                {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
              ),
              customClass: { popup: 'bg-light-danger', title: 'text-danger' },
            })
            clearQueryParams()
          }
        })
      return
    }
    if (responsiblesCount > 1) {
      setShowDeliveryModal(true)
      return
    }
    const CurrentTheme = window.localStorage.getItem('kt_theme_mode_value') || ''
    const tema = CurrentTheme === 'dark' ? '#353b48' : '#fff'
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false,
    })
    swalWithBootstrapButtons
      .fire({
        title: intl.formatMessage({id: 'ALERT.TITLE.TASK.DELIVERY'}),
        icon: 'warning',
        background: tema,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) deliveryItem.mutate()
        else if (result.dismiss === Swal.DismissReason.cancel) {
          Toast.fire({
            icon: 'warning',
            title: intl.formatMessage(
              {id: 'ALERT.LABEL.ERROR_TASK_CLOSE_ITEM'},
              {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
            ),
            customClass: { popup: 'bg-light-danger', title: 'text-danger' },
          })
          clearQueryParams()
        }
      })
  }

  const deliveryItem = useMutation(() => deliveryTask(task?.tasks.id), {
    onSuccess: (response) => {
      Toast.fire({
        icon: response.status === 'success' ? 'success' : 'error',
        title: response.message,
        customClass: {
          popup: response.status === 'success' ? 'bg-light-success' : 'bg-light-error',
          title: TemaAtual === 'dark' ? 'text-dark' : 'text-success',
        },
      })

      if (play === 'run')
        setCurrentUser((user) => ({...user, has_active_time_tracking: false} as UserModel))

      closeModal()
      invalidateAfterTaskChange(queryClient)
      // Invalidar especificamente as queries do calendário
      queryClient.invalidateQueries(['calendar-tasks'])
      // Forçar refetch de todas as queries do calendário
      queryClient.refetchQueries(['calendar-tasks'])
    },
    onError: (error: any) => {
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Ocorreu um erro inesperado',
        customClass: {
          popup: 'bg-light-danger',
          title: TemaAtual === 'dark' ? 'text-dark' : 'text-danger',
        },
      })
    },
  })

  const deliveryPartialItem = useMutation(() => deliveryTaskPartial(task?.tasks.id), {
    onSuccess: (response) => {
      Toast.fire({
        icon: response.status === 'success' ? 'success' : 'error',
        title: response.message,
        customClass: {
          popup: response.status === 'success' ? 'bg-light-success' : 'bg-light-error',
          title: TemaAtual === 'dark' ? 'text-dark' : 'text-success',
        },
      })
      if (play === 'run')
        setCurrentUser((user) => ({...user, has_active_time_tracking: false} as UserModel))
      closeModal()
      invalidateAfterTaskChange(queryClient)
      queryClient.invalidateQueries(['calendar-tasks'])
      queryClient.refetchQueries(['calendar-tasks'])
    },
    onError: (error: any) => {
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Ocorreu um erro inesperado',
        customClass: {
          popup: 'bg-light-danger',
          title: TemaAtual === 'dark' ? 'text-dark' : 'text-danger',
        },
      })
    },
  })

  const reopenPartialItem = useMutation(() => reopenTaskMyPart(task?.tasks.id), {
    onSuccess: (response: {status?: string; message?: string}) => {
      Toast.fire({
        icon: response.status === 'success' ? 'success' : 'error',
        title: response.message || 'Sua parte foi reaberta.',
        customClass: {
          popup: response.status === 'success' ? 'bg-light-success' : 'bg-light-error',
          title: TemaAtual === 'dark' ? 'text-dark' : 'text-success',
        },
      })
      invalidateAfterTaskChange(queryClient)
      queryClient.invalidateQueries(['calendar-tasks'])
      queryClient.refetchQueries(['calendar-tasks'])
    },
    onError: (error: any) => {
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Ocorreu um erro inesperado',
        customClass: {
          popup: 'bg-light-danger',
          title: TemaAtual === 'dark' ? 'text-dark' : 'text-danger',
        },
      })
    },
  })

  const playItem = useMutation(() => playTimeTracking(task?.tasks.id), {
    onSuccess: (response) => {
      Toast.fire({
        icon: 'success',
        title: intl.formatMessage(
          {id: 'ALERT.LABEL.SUCCESS_TIMETRACKING_START'},
          {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TIMETRACKING'})}
        ),
        customClass: {
          popup: 'bg-light-success',
          title: 'text-success',
        },
      })

      invalidateAfterTaskChange(queryClient)
      // Invalidar especificamente as queries do calendário
      queryClient.invalidateQueries(['calendar-tasks'])
      // queryClient.invalidateQueries(`${QUERIES.TASKS_LIST}-task-${task?.tasks.id}`)
      // queryClient.invalidateQueries(`${QUERIES.TASKS_LIST}-${task?.tasks.id}-users`)
      // queryClient.invalidateQueries(`${QUERIES.SPRINTS_LIST}-${sprintId!}`)
      setCurrentUser((user) => {
        return {...user, has_active_time_tracking: true} as UserModel
      })
      setPlay('run')
    },
    onError: (error: any) => {
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Ocorreu um erro inesperado',
        customClass: {
          popup: 'bg-light-danger',
          title: TemaAtual === 'dark' ? 'text-dark' : 'text-danger',
        },
      })
    },
  })

  const stopItem = useMutation(() => stopTimeTracking(task?.tasks.id), {
    onSuccess: (response) => {
      Toast.fire({
        icon: 'success',
        title: intl.formatMessage(
          {id: 'ALERT.LABEL.SUCCESS_TIMETRACKING_STOP'},
          {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TIMETRACKING'})}
        ),
        customClass: {
          popup: 'bg-light-success',
          title: 'text-success',
        },
      })

      // Tudo, como no play: a lista (e o kanban) só param o timer quando são recarregadas.
      invalidateAfterTaskChange(queryClient)
      // Invalidar especificamente as queries do calendário
      queryClient.invalidateQueries(['calendar-tasks'])
      setCurrentUser((user) => {
        return {...user, has_active_time_tracking: false} as UserModel
      })
      setPlay('pause')
    },
  })

  const deleteItem = useMutation(() => deleteTask(task?.tasks.id), {
    onSuccess: (response) => {
      Toast.fire({
        icon: 'success',
        title: intl.formatMessage(
          {id: 'ALERT.LABEL.SUCCESS_TASK_DELETE_ITEM'},
          {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
        ),
        customClass: {
          popup: 'bg-light-success',
          title: 'text-success',
        },
      })
      // Excluir a tarefa com o cronômetro rodando para o cronômetro no servidor.
      invalidateAfterTaskChange(queryClient, {
        refreshSession: !!currentUser?.has_active_time_tracking,
      })
      // Invalidar especificamente as queries do calendário
      queryClient.invalidateQueries(['calendar-tasks'])

      // Remover o parâmetro taskId da URL após exclusão bem-sucedida
      const newParams = new URLSearchParams(searchParams)
      newParams.delete('taskId')
      setSearchParams(newParams)
    },
    onError: (error) => {
      Toast.fire({
        icon: 'error',
        title: error.response.data.message,
        customClass: {
          popup: 'bg-light-danger',
          title: 'text-danger',
        },
      })
    },
  })

  const deleteItemTaskInSprint = useMutation(() => deleteTaskInSprint(task?.tasks.id, sprintId), {
    onSuccess: (response) => {
      Toast.fire({
        icon: 'success',
        title: intl.formatMessage(
          {id: 'ALERT.LABEL.SUCCESS_TASK_UPDATE_ITEM'},
          {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
        ),
        customClass: {
          popup: 'bg-light-success',
          title: 'text-success',
        },
      })
      cancel(true)
      invalidateAfterTaskChange(queryClient)
      // Invalidar especificamente as queries do calendário
      queryClient.invalidateQueries(['calendar-tasks'])
    },
  })

  const initialValues = {
    id: task?.tasks.id,
    file: [],
    name: task?.tasks.name || '',
    description: task?.tasks.description || '',
    begin_date:
      task?.tasks.begin_date && task?.tasks.begin_date.trim() !== ''
        ? task?.tasks.begin_date
        : null,
    expected_date:
      task?.tasks.expected_date && task?.tasks.expected_date.trim() !== ''
        ? task?.tasks.expected_date
        : null,
    project_id: task?.tasks.project_id,
    checklist_concluded: [],
    checklist_name: [],
    users: [],
    tags: [],
    sequence_responsibles: [],
    priority: task?.tasks.priority || null,
    subtasks: [],
    is_public: task?.tasks.is_public || false,
    recurrence: normalizeRecurrenceData(task?.tasks.recurrence || null),
    salesforce_task_id: task?.tasks.salesforce_task_id || null,
    salesforce_catalog_id: task?.tasks.salesforce_catalog_id || null,
    salesforce_case_solution: task?.tasks.salesforce_case_solution || '',
  }

  const priorityOptions = taskPriorityOptions

  const formik = useFormik({
    initialValues: initialValues,
    validate: (values) => {
      const errors: any = {}

      // Validar se o projeto está selecionado
      if (!values.project_id) {
        errors.project_id =
          intl.formatMessage({id: 'VALIDATION.PROJECT_REQUIRED'}) || 'Projeto é obrigatório'
      }

      return errors
    },
    onSubmit: async (values, {setSubmitting, resetForm}) => {
      setSubmitting(true)
      try {
        // Ensure latest name is included
        const payload = {...values, name: name_input}
        await updateTask(payload).then((response) => {
          Toast.fire({
            icon: 'success',
            title: intl.formatMessage(
              {id: 'ALERT.LABEL.SUCCESS_TASK_UPDATE_ITEM'},
              {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
            ),
            customClass: {
              popup: 'bg-light-success',
              title: 'text-success',
            },
          })
          invalidateAfterTaskChange(queryClient)
          // Invalidar especificamente as queries do calendário
          queryClient.invalidateQueries(['calendar-tasks'])
          // Forçar refetch de todas as queries do calendário
          queryClient.refetchQueries(['calendar-tasks'])
          // Reset baselines after successful save
          initialNameRef.current = name_input || ''
          initialDescriptionRef.current = values.description || ''
          initialChecksRef.current = normalizeChecks(checks)
          // Ensure we have a deep copy of the sequence_responsibles
          initialResponsiblesRef.current = JSON.parse(
            JSON.stringify(formik.values.sequence_responsibles || [])
          )
          initialRightPanelRef.current = {
            begin_date: values.begin_date ?? null,
            expected_date: values.expected_date ?? null,
            priority: values.priority ?? null,
            project_id: values.project_id ?? null,
            tagsKey: buildTagsKey(selectedOptions),
            recurrenceKey: buildRecurrenceKey(values.recurrence),
          }
          setIsDescriptionDirty(false)
          setIsChecklistDirty(false)
          setIsResponsiblesDirty(false)
          setIsRightPanelDirty(false)
          setIsNameDirty(false)
          // Modal permanece aberto após salvamento bem-sucedido
        })
      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
      }
    },
  })

  const selectedSubserviceOption =
    subserviceOptions.find(
      (o) => Number(o.value) === Number(formik.values.salesforce_catalog_id)
    ) || null

  const autoSave = useCallback(
    async (
      overrideValues: {
        begin_date?: string | null
        expected_date?: string | null
        sequence_responsibles?: any[]
        recurrence?: any
        priority?: string | null
        description?: string
        tags?: any[]
        project_id?: number | string | null | undefined
        is_public?: boolean
        salesforce_catalog_id?: number | string | null
        salesforce_case_solution?: string | null
      } = {}
    ) => {
      if (isSaving) {
        return
      }

      const currentProjectId =
        overrideValues.project_id !== undefined
          ? overrideValues.project_id
          : formik.values.project_id

      if (!currentProjectId) {
        return
      }

      setIsSaving(true)
      setSaveStatus('saving')

      try {
        const checksConcluded = checks.map((check) => Boolean(check.check))
        const checksNames = checks.map((check) => check.content || '')

        // Get current date values, using overrides if provided
        const currentBeginDate =
          overrideValues.begin_date !== undefined
            ? overrideValues.begin_date
            : formik.values.begin_date
        const currentExpectedDate =
          overrideValues.expected_date !== undefined
            ? overrideValues.expected_date
            : formik.values.expected_date
        const currentSequenceResponsibles =
          overrideValues.sequence_responsibles !== undefined
            ? overrideValues.sequence_responsibles
            : formik.values.sequence_responsibles
        const currentRecurrence =
          overrideValues.recurrence !== undefined
            ? overrideValues.recurrence
            : formik.values.recurrence
        const currentPriority =
          overrideValues.priority !== undefined ? overrideValues.priority : formik.values.priority
        const currentDescription =
          overrideValues.description !== undefined
            ? overrideValues.description
            : formik.values.description
        const currentTags =
          overrideValues.tags !== undefined ? overrideValues.tags : selectedOptions
        const currentIsPublic =
          overrideValues.is_public !== undefined
            ? overrideValues.is_public
            : formik.values.is_public
        const currentSalesforceCatalogId =
          overrideValues.salesforce_catalog_id !== undefined
            ? overrideValues.salesforce_catalog_id
            : formik.values.salesforce_catalog_id
        const currentSalesforceCaseSolution =
          overrideValues.salesforce_case_solution !== undefined
            ? overrideValues.salesforce_case_solution
            : formik.values.salesforce_case_solution

        if (currentBeginDate && currentExpectedDate && !isValidTaskDateTimeRange(currentBeginDate, currentExpectedDate)) {
          setSaveStatus('error')
          Toast.fire({
            icon: 'error',
            title: 'Data de início não pode ser posterior à data de vencimento',
            customClass: {
              popup: 'bg-light-danger',
              title: 'text-danger',
            },
          })
          setIsSaving(false)
          return
        }

        // Build payload directly from current values to avoid Formik async issues
        const payload = {
          id: formik.values.id,
          task_id: formik.values.task_id,
          status: formik.values.status,
          name: name_input,
          description: currentDescription,
          begin_date: currentBeginDate,
          expected_date: currentExpectedDate,
          project_id: currentProjectId,
          creator_id: formik.values.creator_id,
          priority: currentPriority,
          tags: currentTags,
          checklist_concluded: checksConcluded,
          checklist_name: checksNames,
          sequence_responsibles: currentSequenceResponsibles,
          users: currentSequenceResponsibles,
          subtasks: formik.values.subtasks,
          file: formik.values.file,
          recurrence: currentRecurrence,
          is_public: currentIsPublic,
          salesforce_catalog_id: currentSalesforceCatalogId,
          salesforce_case_solution: currentSalesforceCaseSolution,
        }

        const response = await updateTask(payload)

        // The backend recalculates expected_date server-side when salesforce_catalog_id
        // changes (SLA from the catalog), so the modal must reflect that value right away
        // instead of only showing it after the modal is reopened.
        if (
          response?.tasks?.expected_date !== undefined &&
          response.tasks.expected_date !== formik.values.expected_date
        ) {
          formik.setFieldValue('expected_date', response.tasks.expected_date)
        }

        // Update baselines after successful save
        initialNameRef.current = name_input || ''
        initialDescriptionRef.current = formik.values.description || ''
        initialChecksRef.current = normalizeChecks(checks)
        initialResponsiblesRef.current = JSON.parse(
          JSON.stringify(formik.values.sequence_responsibles || [])
        )
        initialRightPanelRef.current = {
          begin_date: formik.values.begin_date ?? null,
          // Use the response's value directly (not formik.values, which won't reflect the
          // setFieldValue call above until the next render) so the dirty baseline matches
          // what's about to be shown on screen.
          expected_date: (response?.tasks?.expected_date ?? formik.values.expected_date) ?? null,
          priority: formik.values.priority ?? null,
          project_id: formik.values.project_id ?? null,
          tagsKey: buildTagsKey(selectedOptions),
          recurrenceKey: buildRecurrenceKey(formik.values.recurrence),
        }

        // Reset dirty flags
        setIsDescriptionDirty(false)
        setIsChecklistDirty(false)
        setIsResponsiblesDirty(false)
        setIsRightPanelDirty(false)
        setIsNameDirty(false)

        setSaveStatus('saved')

        // Clear "saved" status after 2 seconds
        if (saveTimeoutRef.current) {
          clearTimeout(saveTimeoutRef.current)
        }
        saveTimeoutRef.current = setTimeout(() => {
          setSaveStatus('idle')
        }, 2000)

        // Invalidate queries
        invalidateAfterTaskChange(queryClient)
        queryClient.invalidateQueries(['calendar-tasks'])
        queryClient.refetchQueries(['calendar-tasks'])
      } catch (error: any) {
        console.error('Auto-save error:', error)
        setSaveStatus('error')
        Toast.fire({
          icon: 'error',
          title: error.response?.data?.message || 'Erro ao salvar alterações',
          customClass: {
            popup: 'bg-light-danger',
            title: 'text-danger',
          },
        })
      } finally {
        setIsSaving(false)
      }
    },
    [isSaving, formik.values, selectedOptions, checks, name_input, queryClient, intl]
  )

  const triggerAutoSave = useCallback(
    (
      overrideValues: {
        begin_date?: string | null
        expected_date?: string | null
        sequence_responsibles?: any[]
        recurrence?: any
        priority?: string | null
        description?: string
        tags?: any[]
        project_id?: number | string | null | undefined
        salesforce_catalog_id?: number | string | null
        salesforce_case_solution?: string | null
      } = {}
    ) => {
      if (autoSaveDebounceRef.current) {
        clearTimeout(autoSaveDebounceRef.current)
      }
      autoSaveDebounceRef.current = setTimeout(() => {
        const currentProjectId =
          overrideValues.project_id !== undefined
            ? overrideValues.project_id
            : formik.values.project_id
        if (!isSaving && currentProjectId) {
          autoSave(overrideValues)
        }
      }, 500)
    },
    [isSaving, formik.values.project_id, autoSave]
  )

  const debouncedAutoSave = useCallback(() => {
    if (checklistDebounceRef.current) {
      clearTimeout(checklistDebounceRef.current)
    }
    checklistDebounceRef.current = setTimeout(() => {
      if (isChecklistDirty && formik.values.project_id) {
        autoSave()
      }
    }, 300)
  }, [isChecklistDirty, formik.values.project_id, autoSave])

  const submitForm = useCallback(
    async (e: any) => {
      formik.setFieldValue('tags', selectedOptions)
      // Ensure latest values are synced before submit
      formik.setFieldValue('name', name_input)

      // Garantir que os arrays do checklist estão limpos e únicos
      const checksConcluded = checks.map((check) => Boolean(check.check))
      const checksNames = checks.map((check) => check.content || '')

      formik.setFieldValue('checklist_concluded', checksConcluded)
      formik.setFieldValue('checklist_name', checksNames)

      // Validar se o projeto está selecionado antes de submeter
      if (!formik.values.project_id) {
        formik.setFieldTouched('project_id', true)
        formik.setFieldError(
          'project_id',
          intl.formatMessage({id: 'VALIDATION.PROJECT_REQUIRED'}) || 'Projeto é obrigatório'
        )
        return
      }

      // Small delay to ensure formik state is updated
      setTimeout(() => {
        formik.submitForm()
      }, 0)
    },
    [formik, selectedOptions, checks, intl, name_input]
  )

  useEffect(() => {
    formik.setFieldValue('task_id', data.id)
    formik.setFieldValue('status', data.status)
    formik.setFieldValue('name', name_input)
    formik.setFieldValue('description', description_input)
    // Don't override expected_date with delivery_date_input to avoid corruption
    formik.setFieldValue('project_id', task?.tasks.project_id)
    formik.setFieldValue('creator_id', task?.tasks.creator_id)
  }, [name_input, description_input])

  useEffect(() => {
    setIsNameDirty((name_input || '') !== (initialNameRef.current || ''))
  }, [name_input])

  const CustomToggle = forwardRef((props: CustomToggleProps, ref: React.Ref<HTMLAnchorElement>) => (
    <a
      href=''
      className='text-hover-primary'
      ref={ref}
      onClick={(e) => {
        e.preventDefault()
        props.onClick(e)
      }}
    >
      {props.children}
      <span style={{paddingLeft: '5px'}}></span>
    </a>
  ))

  const handleCreateProjectAndClient = (newProjectName: string) => {
    setSearchParams({new_project_name: newProjectName})
    setShowProjectAndClientModal(true)
  }

  const openTask = async () => {
    const CurrentTheme = window.localStorage.getItem('kt_theme_mode_value') || ''
    const theme = CurrentTheme === 'dark' ? '#353b48' : '#fff'

    const optionsHtml = task?.tasks.sequence_responsibles
      .map(
        (option, index) =>
          `<option index="${index}" value="${option.id}" data-order="${option.pivot.order}">${option.name}</option>`
      )
      .join('')

    task?.tasks.sequence_responsibles.length > 0
      ? Swal.fire({
          title: 'Confirmação de Reabertura de Tarefa',
          html: `
              <p class='mb-6'>Esta tarefa possui sequência de responsáveis. Por favor, selecione o usuário para quem a tarefa será reaberta.</p>
              <div class='text-start'>
                <label class='fs-6 fw-semibold form-label mb-2'>
                  Escolha o responsável para reabrir a tarefa:
                </label>
                <select 
                  id="sequenceResponsiblesSelect" 
                  class='form-select form-select-sm form-select-solid'
                  value='${selectedResponsibleId}'>
                  ${optionsHtml}
                </select>
              </div>
            `,
          icon: 'warning',
          background: theme,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: 'Reabrir tarefa',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
          preConfirm: () => {
            const select = document.getElementById('sequenceResponsiblesSelect')
            const selectedOption = select.options[select.selectedIndex]

            return {
              id: selectedOption.value,
              order: selectedOption.dataset.order,
            }
          },
        }).then((result) => {
          if (result.isConfirmed) {
            updateStatusTask(task?.tasks.id, 'Backlog', result.value.id, result.value.order)
              .then((response) => {
                Toast.fire({
                  icon: 'success',
                  title: intl.formatMessage(
                    {id: 'ALERT.LABEL.SUCCESS_TASK_OPEN_ITEM'},
                    {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
                  ),
                  customClass: {
                    popup: 'bg-light-success',
                    title: 'text-success',
                  },
                })

                invalidateAfterTaskChange(queryClient)
                // Invalidar especificamente as queries do calendário
                queryClient.invalidateQueries(['calendar-tasks'])
                cancel(true)
              })
              .catch((e) => {
                Swal.fire({
                  icon: 'error',
                  title: 'Erro',
                  html: '<h5>' + e.response?.data.message + '</h5>',
                  background: theme,
                  confirmButtonColor: '#b5d44e',
                  color: '#fff',
                })
              })
          }
        })
      : updateStatusTask(task?.tasks.id, 'Backlog')
          .then(() => {
            Toast.fire({
              icon: 'success',
              title: intl.formatMessage(
                {id: 'ALERT.LABEL.SUCCESS_TASK_OPEN_ITEM'},
                {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
              ),
              customClass: {
                popup: 'bg-light-success',
                title: 'text-success',
              },
            })
            invalidateAfterTaskChange(queryClient)
            // Invalidar especificamente as queries do calendário
            queryClient.invalidateQueries(['calendar-tasks'])
            cancel(true)
          })
          .catch((e) => {
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              html: '<h5>' + e.response?.data.message + '</h5>',
              background: theme,
              confirmButtonColor: '#b5d44e',
              color: '#fff',
            })
          })
  }

  const openCloneTask = () => {
    setItemIdForUpdate(task?.tasks.id)
    // Primeiro define o cloneTaskId nos searchParams para abrir o modal de clone
    const newParams = new URLSearchParams(searchParams)
    newParams.set('cloneTaskId', task?.tasks.id?.toString() || '')
    newParams.delete('taskId') // Remove o taskId para fechar o modal de edição
    setSearchParams(newParams)
  }

  function handleOpenTaskModal() {
    const params = new URLSearchParams(searchParams)
    params.set('taskId', String(task?.tasks.parent_id))
    setSearchParams(params)
  }

  // Track responsible sequence via formik.values.sequence_responsibles changes
  useEffect(() => {
    try {
      const initial = initialResponsiblesRef.current || []
      const current = formik.values.sequence_responsibles || []

      // Normalize both arrays for comparison
      const normalizeResponsibles = (arr: any[]) => {
        if (!Array.isArray(arr)) return []
        return arr
          .map((item, index) => {
            if (!item || typeof item !== 'object') return null
            return {
              id: item?.id || item?.user_id || item?.value || null,
              name: item?.name || item?.label || '',
              order: item?.pivot?.order || item?.order || index,
            }
          })
          .filter(Boolean)
          .sort((a, b) => a.order - b.order)
      }

      const normalizedInitial = normalizeResponsibles(initial)
      const normalizedCurrent = normalizeResponsibles(current)

      const initialStr = JSON.stringify(normalizedInitial)
      const currentStr = JSON.stringify(normalizedCurrent)

      setIsResponsiblesDirty(initialStr !== currentStr)
    } catch (error) {
      console.error('Error in responsible sequence comparison:', error)
      setIsResponsiblesDirty(false)
    }
  }, [formik.values.sequence_responsibles])

  const handleRecurrenceChange = useCallback(
    (field: string, recurrenceData: any) => {
      if (field !== 'recurrence') {
        formik.setFieldValue(field, recurrenceData)
        return
      }

      formik.setFieldValue('recurrence', recurrenceData)

      const snap = initialRightPanelRef.current
      const currentRecurrenceKey = buildRecurrenceKey(recurrenceData)
      const now: RightPanelSnapshot = {
        begin_date: formik.values.begin_date,
        expected_date: formik.values.expected_date,
        priority: formik.values.priority,
        project_id: formik.values.project_id,
        tagsKey: buildTagsKey(selectedOptions),
        recurrenceKey: currentRecurrenceKey,
      }
      const isDirty =
        snap.begin_date !== now.begin_date ||
        snap.expected_date !== now.expected_date ||
        String(snap.priority || '') !== String(now.priority || '') ||
        String(snap.project_id || '') !== String(now.project_id || '') ||
        snap.tagsKey !== now.tagsKey ||
        snap.recurrenceKey !== now.recurrenceKey

      setIsRightPanelDirty(isDirty)

      if (isDirty && formik.values.project_id) {
        triggerAutoSave({recurrence: recurrenceData})
      }
    },
    [formik.values, selectedOptions, triggerAutoSave]
  )

  return (
    <>
      <div className='modal-content task-modal-content'>
        <div id='kt_modal_add_project_milestone_form' className='form'>
          <div className='modal-header border-0 row justify-content-end'>
            <div className='col-11 col-md-6 me-auto'>
              {!!task?.tasks.parent_id && (
                <span
                  onClick={handleOpenTaskModal}
                  role='button'
                  className='fs-8 text-primary ms-2'
                >
                  {task?.tasks.parent_name}
                </span>
              )}
              <input
                value={name_input}
                onChange={(e: any) => setNameInput(e.target.value)}
                onBlur={() => {
                  if (isNameDirty && formik.values.project_id) {
                    triggerAutoSave()
                  }
                }}
                placeholder={intl.formatMessage({id: 'FORM.INPUT.NAME.TASK_TITLE'})}
                type='text'
                name='name'
                onKeyPress={(e) => {
                  e.key === 'Enter' && e.preventDefault()
                }}
                className={clsx('form-control py-2 bg-transparent border-0 fs-1')}
                autoComplete='off'
              />
            </div>

            <div className='col-1 d-flex justify-content-end align-items-center d-md-none px-0 pe-3'>
              <button
                className='btn btn-sm btn-icon btn-active-color-primary h-auto'
                onClick={(e) => {
                  if (e.detail === 0) return
                  closeModal()
                }}
              >
                <KTSVG
                  className='svg-icon-2x svg-icon-gray-800'
                  path='/media/icons/duotune/arrows/arr061.svg'
                />
              </button>
            </div>

            {statustask.toLowerCase() === 'entregue' && <div className='col-2 col-md-1'></div>}

            {/*< TIMETRACKING />*/}
            {statustask.toLowerCase() !== 'entregue' && !myPartConcluded && (
              <div className='col-2 col-md-1 d-flex justify-content-end pe-2'>
                <div
                  className='symbol symbol-28px symbol-circle timetracking_button timetracking-button-hover cursor-pointer '
                  onClick={startAndStop}
                >
                  {play === 'run' ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='28'
                      height='28'
                      fill='currentColor'
                      className='bi bi-pause-circle'
                      viewBox='0 0 16 16'
                      style={{color: '#50b840'}}
                    >
                      <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
                      <path d='M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5z' />
                    </svg>
                  ) : (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='28'
                      height='28'
                      fill='currentColor'
                      className='bi bi-play-circle'
                      viewBox='0 0 16 16'
                      style={{color: '#009ef7'}}
                    >
                      <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
                      <path d='M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z' />
                    </svg>
                  )}
                </div>
              </div>
            )}

            {statustask.toLowerCase() !== 'entregue' && !myPartConcluded && (
              <div
                className='col-2 col-md-1 symbol symbol-28px symbol-circle timetracking_button timetracking-button-hover'
                onClick={() => entregatask()}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='28'
                  height='28'
                  fill='currentColor'
                  className='bi bi-check2-circle cursor-pointer '
                  viewBox='0 0 16 16'
                  style={{color: '#5d7a1f'}}
                >
                  <path d='M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z' />
                  <path d='M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z' />
                </svg>
              </div>
            )}

            <div className='col-2 col-md-1 d-flex justify-content-end pe-4'>
              {play === 'run' ? (
                <p
                  className={clsx('bg-transparent fs-3')}
                  style={{color: '#50b840', marginTop: '15px', marginRight: '-15px'}}
                >
                  {hours}:{minutes.toString().padStart(2, '0')}:
                  {seconds.toString().padStart(2, '0')}
                </p>
              ) : (
                <p
                  className={clsx('bg-transparent fs-3')}
                  style={{color: '#009ef7', marginTop: '15px', marginRight: '-15px'}}
                >
                  {hours}:{minutes.toString().padStart(2, '0')}:
                  {seconds.toString().padStart(2, '0')}
                </p>
              )}
            </div>
            {/*< TIMETRACKING />*/}

            {/* No mobile, essa linha não tem espaço pro grupo de avatares — em vez de
                escondê-lo (era `d-none d-md-flex`, sem nenhuma forma de ver/editar
                responsáveis no celular), ele desce pra uma linha própria abaixo do resto. */}
            <div className='col-12 col-md-2 order-last order-md-0 d-flex justify-content-start justify-content-md-end pe-4 mt-3 mt-md-0'>
              <UsersSymbolGroupColumn
                users={
                  formik.values.sequence_responsibles.length > 0
                    ? formik.values.sequence_responsibles
                    : dataUsers?.tasks?.users!
                }
                usersAll={dataUsers?.tasks?.usersAll!}
                taskId={data.id}
                isReadonly={formik.values.sequence_responsibles.length > 0}
              />
            </div>

            <div className='col-2 col-md-1 d-flex justify-content-end align-items-center'>
              <div className='actions pt-1'>
                <Dropdown>
                  <Dropdown.Toggle as={CustomToggle} id='dropdown-custom-components'>
                    <i className='bi bi-list-ul fs-1 text-dark'></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={(e) => {
                        e.preventDefault()
                        setShowAdjustTimeModal(true)
                      }}
                      eventKey='1'
                    >
                      {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.ADJUST_TIMETRACKING'})}
                    </Dropdown.Item>
                    {statustask?.toLowerCase() === 'entregue' ? (
                      <Dropdown.Item onClick={openTask} eventKey='4'>
                        {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.OPEN_TASK'})}
                      </Dropdown.Item>
                    ) : myPartConcluded ? (
                      <Dropdown.Item onClick={() => reopenPartialItem.mutate()} eventKey='4'>
                        Reabrir minha parte
                      </Dropdown.Item>
                    ) : (
                      <Dropdown.Item onClick={entregatask} eventKey='4'>
                        {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.FINIS_TASK'})}
                      </Dropdown.Item>
                    )}
                    {!currentUser?.external_user && (
                      <>
                        <Dropdown.Item onClick={openCloneTask} eventKey='5'>
                          {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.CLONE_TASK'})}
                        </Dropdown.Item>
                        {canDelete && (
                          <Dropdown.Item onClick={deleta} eventKey='3'>
                            {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.DELETE'})}
                          </Dropdown.Item>
                        )}
                        {sprintId && canDelete && (
                          <Dropdown.Item onClick={deletaTaskInSprint} eventKey='4'>
                            {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.DELETE.TASK.SPRINT'})}
                          </Dropdown.Item>
                        )}
                      </>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
                {/* end::Menu */}
              </div>
              <button
                className='btn btn-sm btn-icon btn-active-color-primary d-none d-md-block h-auto ms-4'
                onClick={(e) => {
                  if (e.detail === 0) return
                  closeModal()
                }}
              >
                <KTSVG
                  className='svg-icon-2x svg-icon-gray-800'
                  path='/media/icons/duotune/arrows/arr061.svg'
                />
              </button>
            </div>
          </div>
          <div className='modal-body d-flex flex-column flex-lg-row justify-content-between'>
            <div className='col-lg-8 pe-5 pb-5 pb-lg-0 mb-15 mb-lg-0 border-bottom border-bottom-lg-0 d-flex flex-column'>
              <ul
                className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap overflow-x-scroll overflow-y-hidden'
                role='tablist'
              >
                <li className='nav-item'>
                  <a
                    className='nav-link cursor-pointer text-gray-900 active'
                    data-bs-toggle='tab'
                    href={`#${tabIds.description}`}
                  >
                    Descrição
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className='nav-link cursor-pointer text-gray-900'
                    data-bs-toggle='tab'
                    href={`#${tabIds.attachments}`}
                  >
                    {intl.formatMessage({id: 'TASK.TABLE.ATTACHMENTS'})}
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className='nav-link cursor-pointer text-gray-900'
                    data-bs-toggle='tab'
                    href={`#${tabIds.checklist}`}
                  >
                    {intl.formatMessage({id: 'TASK.TABLE.CHECKLIST'})}
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className='nav-link cursor-pointer text-gray-900'
                    data-bs-toggle='tab'
                    href={`#${tabIds.comments}`}
                  >
                    {intl.formatMessage({id: 'TASK.TABLE.COMMENTS'})}
                  </a>
                </li>
                {!currentUser?.external_user && (
                  <>
                    <li className='nav-item'>
                      <a
                        className='nav-link cursor-pointer text-gray-900 d-flex align-items-center'
                        data-bs-toggle='tab'
                        href={`#${tabIds.subtasks}`}
                      >
                        <span>{intl.formatMessage({id: 'TASK.TABLE.SUBTASKS'})}</span>
                        <span className='badge badge-light-primary ms-2'>
                          {task?.tasks?.subtasks?.length || 0}
                        </span>
                      </a>
                    </li>
                    <li className='nav-item align-items-center align-items-center'>
                      <a
                        className='nav-link cursor-pointer text-gray-900'
                        data-bs-toggle='tab'
                        href={`#${tabIds.responsibleSequence}`}
                      >
                        {intl.formatMessage({id: 'TASK.TABLE.RESPONSIBLE_SEQUENCE'})}
                      </a>
                      <OverlayTrigger
                        placement='top'
                        delay={{show: 50, hide: 100}}
                        overlay={
                          <Tooltip>
                            Crie uma sequência de responsáveis e organize a passagem de bastão da
                            tarefa. Assim, ao entregar uma parte, a tarefa será transferida de forma
                            automática para o próximo usuário.
                          </Tooltip>
                        }
                      >
                        <i className='fas fa-exclamation-circle ms-2 fs-7' />
                      </OverlayTrigger>
                    </li>
                  </>
                )}
              </ul>
              <div className='tab-content pt-3 overflow-y-auto overflow-x-hidden h-100'>
                <div
                  id={tabIds.description}
                  className='task-ckeditor-container tab-pane fade show active'
                >
                  {!canEditDescription && (
                    <div className='alert alert-light-warning d-flex align-items-center py-3 mb-4'>
                      <i className='bi bi-lock-fill fs-4 text-warning me-3'></i>
                      <div className='fw-semibold text-gray-800'>
                        A descrição está em modo somente leitura. Apenas gestores, administradores e o
                        criador da tarefa podem editar.
                      </div>
                    </div>
                  )}
                  <CKEditor
                    // @ts-ignore
                    editor={SourceEditingEditor}
                    disabled={formik.isSubmitting || !canEditDescription}
                    id='description'
                    onChange={(event: any, editor: any) => {
                      if (!canEditDescription) {
                        return
                      }
                      const value = editor.getData()
                      formik.setFieldValue('description', value)
                      setIsDescriptionDirty(value !== initialDescriptionRef.current)
                    }}
                    onBlur={(event: any, editor: any) => {
                      if (!canEditDescription) {
                        return
                      }
                      if (isDescriptionDirty && formik.values.project_id) {
                        const value = editor.getData()
                        triggerAutoSave({description: value})
                      }
                    }}
                    config={{
                      extraPlugins: [StripColorsOnPaste],
                      toolbar: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        '|',
                        'link',
                        'blockQuote',
                        '|',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'uploadImage',
                      ],
                      simpleUpload: {
                        uploadUrl: `${process.env.REACT_APP_THEME_API_URL || process.env.REACT_APP_API_URL || ''}/api/upload`,
                        headers: {
                          Authorization: 'Bearer ' + auth?.api_token,
                        },
                      },
                      initialData: formik.getFieldProps('description').value,
                    } as any}
                  />

                  {isSalesforceTask && (
                    <div className='pt-6'>
                      <div className='row g-4 m-0'>
                        <div className='col-md-6 min-w-0 px-0 pe-md-3'>
                          <label className='fw-bold text-dark me-1' htmlFor='salesforce-tipo'>
                            Tipo (Salesforce)
                          </label>
                          <Select
                            inputId='salesforce-tipo'
                            placeholder='Selecione o tipo'
                            options={typeOptions}
                            value={typeOptions.find((o) => o.value === selectedType) || null}
                            onChange={(newValue) => {
                              setSelectedType(newValue?.value || null)
                              setSelectedService(null)
                              formik.setFieldValue('salesforce_catalog_id', null)
                              triggerAutoSave({salesforce_catalog_id: null})
                            }}
                            classNames={{
                              control: () => 'form-control form-control-solid py-1',
                              menu: () => 'bg-body',
                            }}
                            styles={salesforceSelectStyles}
                            isSearchable={false}
                          />
                        </div>
                        <div className='col-md-6 min-w-0 px-0 ps-md-3'>
                          <label className='fw-bold text-dark me-1' htmlFor='salesforce-servico'>
                            Serviço (Salesforce)
                          </label>
                          <Select
                            inputId='salesforce-servico'
                            placeholder='Selecione o serviço'
                            options={serviceOptions}
                            value={serviceOptions.find((o) => o.value === selectedService) || null}
                            isDisabled={!selectedType}
                            onChange={(newValue) => {
                              setSelectedService(newValue?.value || null)
                              formik.setFieldValue('salesforce_catalog_id', null)
                              triggerAutoSave({salesforce_catalog_id: null})
                            }}
                            classNames={{
                              control: () => 'form-control form-control-solid py-1',
                              menu: () => 'bg-body',
                            }}
                            styles={salesforceSelectStyles}
                            isSearchable={false}
                          />
                        </div>
                        <div className='col-12 min-w-0 px-0 pt-4'>
                          <label className='fw-bold text-dark me-1' htmlFor='salesforce-subservico'>
                            Subserviço (Salesforce)
                          </label>
                          <Select
                            inputId='salesforce-subservico'
                            placeholder='Selecione o subserviço'
                            options={subserviceOptions}
                            value={selectedSubserviceOption}
                            isDisabled={!selectedService}
                            onChange={(newValue) => {
                              const newId = newValue?.value ?? null
                              formik.setFieldValue('salesforce_catalog_id', newId)
                              triggerAutoSave({salesforce_catalog_id: newId})
                            }}
                            classNames={{
                              control: () => 'form-control form-control-solid py-1',
                              menu: () => 'bg-body',
                            }}
                            styles={salesforceSelectStyles}
                            isSearchable={false}
                          />
                          <div className='form-text text-muted'>
                            Define o SLA que calcula automaticamente o prazo de entrega desta tarefa.
                          </div>
                        </div>
                      </div>
                      <div className='pt-4'>
                        <label className='fw-bold text-dark me-1' htmlFor='salesforce-case-solution'>
                          Solução do Caso
                        </label>
                        <textarea
                          id='salesforce-case-solution'
                          className='form-control form-control-solid'
                          rows={3}
                          placeholder='Obrigatório para entregar esta tarefa'
                          value={formik.values.salesforce_case_solution || ''}
                          onChange={(e) =>
                            formik.setFieldValue('salesforce_case_solution', e.target.value)
                          }
                          onBlur={() =>
                            triggerAutoSave({
                              salesforce_case_solution: formik.values.salesforce_case_solution,
                            })
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>

                <div id={tabIds.attachments} className='tab-pane fade'>
                  <div className='pt-6'>
                    <OverviewAttachement taskId={task?.tasks.id} />
                  </div>
                </div>

                <div id={tabIds.checklist} className='tab-pane fade'>
                  <TaskChecklistEditor
                    items={checks}
                    onChange={handleChecklistChange}
                    disabled={formik.isSubmitting}
                    onItemBlur={debouncedAutoSave}
                  />
                </div>

                <div id={tabIds.comments} className='tab-pane fade'>
                  <TaskComments comments={task?.tasks.comments} />
                </div>

                {!currentUser?.external_user && (
                  <>
                    <Subtasks
                      tabId={tabIds.subtasks}
                      formikSetFieldValue={formik.setFieldValue}
                      tasks={task?.tasks.subtasks}
                      parentTask={task?.tasks}
                      usersAll={task?.tasks.usersAll}
                    />

                    <TaskSequenceResponsibles
                      tabId={tabIds.responsibleSequence}
                      formikSetFieldValue={formik.setFieldValue}
                      users={dataUsers?.tasks?.usersAll}
                      responsibles={formik.values.sequence_responsibles}
                      onAutoSave={triggerAutoSave}
                    />
                  </>
                )}
              </div>
            </div>
            <div className='col-lg-4 border-start-lg ps-lg-10'>
              <div className='border-bottom pb-8'>
                <div className='d-flex align-items-center mb-3'>
                  <i className='bi bi-calendar-range me-2 text-primary fs-5'></i>
                  <span className='fw-bold text-dark'>Datas</span>
                </div>

                <div className='d-flex align-items-center gap-3 mb-4'>
                  <div className='d-flex align-items-center gap-2'>
                    <i className='bi bi-calendar-plus text-muted fs-5'></i>
                    <span className='text-muted'>Início</span>
                    <i className='bi bi-arrow-right text-muted'></i>
                  </div>

                  <div className='d-flex align-items-center gap-2'>
                    <i className='bi bi-calendar-plus text-muted fs-5'></i>
                    <span className='text-muted'>Vencimento</span>
                  </div>
                </div>

                <TaskDateTimeFields
                  beginDateTime={formik.values.begin_date}
                  expectedDateTime={formik.values.expected_date}
                  onBeginDateTimeChange={(value) => {
                    formik.setFieldValue('begin_date', value)
                    computeRightPanelDirty({begin_date: value})
                    triggerAutoSave({begin_date: value, expected_date: formik.values.expected_date})
                  }}
                  onExpectedDateTimeChange={(value) => {
                    formik.setFieldValue('expected_date', value)
                    setDeliveryDateInput(value || '')
                    computeRightPanelDirty({expected_date: value})
                    triggerAutoSave({begin_date: formik.values.begin_date, expected_date: value})
                  }}
                  showExpectedDate={
                    !formik.values.sequence_responsibles?.some(
                      (responsible: any) =>
                        responsible?.expected_date &&
                        responsible.expected_date !== '' &&
                        responsible.expected_date !== 'null'
                    ) || !!currentUser?.external_user
                  }
                  disabled={!!currentUser?.external_user}
                  beginPlaceholder='Data inicial'
                  expectedPlaceholder='Data de vencimento'
                  minBeginDate={new Date()}
                  minExpectedDate={toDatePickerValue(formik.values.begin_date) || new Date()}
                />

                <div className='d-flex mb-4 mt-6'>
                  <span className='fw-bold text-dark me-1'>
                    {intl.formatMessage({id: 'TASK.LABEL.TASK_ID'})} {data.id}
                  </span>
                </div>

                <div className='d-flex mb-4'>
                  <span className='fw-bold text-dark me-1'>
                    {intl.formatMessage({id: 'TASK.LABEL.CREATOR_DEADLINE'})} {data.creator_name}
                  </span>
                </div>

                {!!data.project_stage && (
                  <div className='d-flex mb-4'>
                    <span className='fw-bold text-dark me-1'>
                      Etapa do projeto: {data.project_stage.name}
                    </span>
                  </div>
                )}

                {/* Data de entrega - exibida apenas quando a tarefa está entregue */}
                <div className='d-flex mb-4'>
                  <span className='fw-bold text-dark me-1'>
                    {intl.formatMessage({id: 'FORM.INPUT.NAME.CREATED_AT'})} {data.created_at}
                  </span>
                </div>

                {/* Informação de Sprint(s) */}
                {(() => {
                  const sprintList: Array<{sprint_id: number; sprint_name: string}> =
                    data.sprints?.length
                      ? (data.sprints as any)
                      : data.sprint_id && data.sprint_name
                        ? [
                            {
                              sprint_id: data.sprint_id,
                              sprint_name: data.sprint_name,
                              // Alguns endpoints não retornam begin/end quando vem via `sprint_id/sprint_name`.
                              ...(data as any),
                            },
                          ]
                        : []
                  if (sprintList.length === 0) return null
                  return (
                    <div className='d-flex flex-wrap align-items-center mb-4'>
                      <span className='fw-bold text-dark me-1'>Sprints: </span>
                      <span>
                        {sprintList.map((sprint, index, arr) => (
                          <span key={sprint.sprint_id}>
                            <Link
                              to={`/sprints?sprintId=${sprint.sprint_id}`}
                              className='text-dark text-decoration-underline'
                            >
                              {sprint.sprint_name}
                            </Link>
                            {index < arr.length - 1 ? ', ' : ''}
                          </span>
                        ))}
                      </span>
                    </div>
                  )
                })()}
              </div>

              <div className='pt-10'>
                <div className='form-check form-check-custom form-check-solid'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    id='is_public_edit'
                    checked={formik.values.is_public || false}
                    onChange={(e) => {
                      formik.setFieldValue('is_public', e.target.checked)
                      triggerAutoSave({is_public: e.target.checked})
                    }}
                    disabled={currentUser?.external_user}
                    style={{cursor: 'pointer'}}
                  />
                  <label
                    className='form-check-label fw-bold text-dark'
                    htmlFor='is_public_edit'
                    style={{cursor: 'pointer'}}
                    onClick={(e) => {
                      if (!currentUser?.external_user) {
                        e.preventDefault()
                        const newValue = !formik.values.is_public
                        formik.setFieldValue('is_public', newValue)
                        triggerAutoSave({is_public: newValue})
                      }
                    }}
                  >
                    Tarefa Pública
                  </label>
                </div>
                <div className='form-text text-muted'>
                  Tarefas públicas serão visíveis na URL pública do projeto
                </div>
              </div>

              <div className='pt-4'>
                <div>
                  <label className='fw-bold text-dark me-1'>Prioridade:</label>
                  <CreatableSelect
                    isClearable={!currentUser?.external_user}
                    isDisabled={currentUser?.external_user}
                    placeholder={'Selecione a prioridade'}
                    options={[
                      {label: 'Baixa', value: 'baixa'},
                      {label: 'Média', value: 'media'},
                      {label: 'Alta', value: 'alta'},
                      {label: 'Crítica', value: 'critica'},
                    ]}
                    value={priorityOptions.find(
                      (priority) => priority.value == formik.values.priority
                    )}
                    onChange={(newValue) => {
                      const newPriority = newValue?.value || null
                      formik.setFieldValue('priority', newPriority)
                      const snap = initialRightPanelRef.current
                      const now: RightPanelSnapshot = {
                        begin_date: formik.values.begin_date,
                        expected_date: formik.values.expected_date,
                        priority: newPriority,
                        project_id: formik.values.project_id,
                        tagsKey: buildTagsKey(selectedOptions),
                      }
                      setIsRightPanelDirty(
                        snap.begin_date !== now.begin_date ||
                          snap.expected_date !== now.expected_date ||
                          String(snap.priority || '') !== String(now.priority || '') ||
                          String(snap.project_id || '') !== String(now.project_id || '') ||
                          snap.tagsKey !== now.tagsKey
                      )
                      triggerAutoSave({priority: newPriority})
                    }}
                    classNames={{
                      control: (state) => 'form-control form-control-solid py-1',
                      input: (state) => 'text-dark',
                      singleValue: (state) => 'text-dark',
                      menu: (state) => 'bg-body',
                    }}
                    isSearchable={false}
                    styles={{
                      option: (styles, {data, isDisabled, isFocused, isSelected}) => {
                        return {
                          ...styles,
                          backgroundColor: isDisabled
                            ? undefined
                            : isSelected
                            ? '#b5d44e70'
                            : isFocused
                            ? '#b5d44e70'
                            : undefined,
                          color: isDisabled ? '#ccc' : isSelected ? '#181C32' : undefined,
                        }
                      },
                      clearIndicator(styles, props) {
                        return {
                          ...styles,
                          cursor: 'pointer',
                        }
                      },
                    }}
                  />
                </div>
              </div>

              <div className='pt-4'>
                <div>
                  <label className='fw-bold text-dark me-1'>Tags:</label>
                  <TagsAutoComplete
                    selectedOptions={selectedOptions}
                    isDisabled={currentUser?.external_user}
                    setSelectedOptions={(opts) => {
                      setSelectedOptions(opts)
                      const snap = initialRightPanelRef.current
                      const now: RightPanelSnapshot = {
                        begin_date: formik.values.begin_date,
                        expected_date: formik.values.expected_date,
                        priority: formik.values.priority,
                        project_id: formik.values.project_id,
                        tagsKey: buildTagsKey(opts as any[]),
                      }
                      setIsRightPanelDirty(
                        snap.begin_date !== now.begin_date ||
                          snap.expected_date !== now.expected_date ||
                          String(snap.priority || '') !== String(now.priority || '') ||
                          String(snap.project_id || '') !== String(now.project_id || '') ||
                          snap.tagsKey !== now.tagsKey
                      )
                      triggerAutoSave({tags: opts as any[]})
                    }}
                  />
                </div>
              </div>

              <div className='pt-4'>
                <div>
                  <div className='d-flex fw-bold text-dark align-items-center'>
                    <span>{intl.formatMessage({id: 'TASK.LABEL.PROJECT'})} </span>
                    <span className='text-danger ms-1'>*</span>
                  </div>
                  <SelectAutoComplete
                    endPoint='projetos'
                    value={{value: task?.tasks.project_id, label: task?.tasks.project_name!}}
                    placeholder={intl.formatMessage({id: 'FORM.INPUT.TOOLTIP.PROJECT'})}
                    onChange={(e) => {
                      const newProjectId = e?.value
                      formik.setFieldValue('project_id', newProjectId)
                      // Limpar erro quando projeto for selecionado
                      if (newProjectId && formik.errors.project_id) {
                        formik.setFieldError('project_id', '')
                      }
                      const snap = initialRightPanelRef.current
                      const now: RightPanelSnapshot = {
                        begin_date: formik.values.begin_date,
                        expected_date: formik.values.expected_date,
                        priority: formik.values.priority,
                        project_id: newProjectId,
                        tagsKey: buildTagsKey(selectedOptions),
                      }
                      setIsRightPanelDirty(
                        snap.begin_date !== now.begin_date ||
                          snap.expected_date !== now.expected_date ||
                          String(snap.priority || '') !== String(now.priority || '') ||
                          String(snap.project_id || '') !== String(now.project_id || '') ||
                          snap.tagsKey !== now.tagsKey
                      )
                      triggerAutoSave({project_id: newProjectId})
                    }}
                    onCreateOption={(inputValue) => handleCreateProjectAndClient(inputValue)}
                    isDisabled={currentUser?.external_user}
                  />
                  {formik.errors.project_id && formik.touched.project_id && (
                    <div className='text-danger fs-7 mt-1'>{formik.errors.project_id}</div>
                  )}
                  {formik.values.project_id && (
                    <Link
                      to={`/projects/${formik.values.project_id}`}
                      className='d-flex-inline text-dark align-items-center text-decoration-underline'
                    >
                      Ir para o projeto{' '}
                      <i className='bi bi-box-arrow-up-right fw-bold text-dark ms-1'></i>
                    </Link>
                  )}
                </div>
              </div>

              <div className='d-flex justify-content-between align-items-center text-center pt-7 gap-3'>
                <div className='d-flex gap-2 align-items-center'>
                  <TaskRecurrence
                    formikSetFieldValue={handleRecurrenceChange}
                    recurrenceData={
                      formik.values.recurrence
                        ? normalizeRecurrenceData(formik.values.recurrence)
                        : null
                    }
                  />
                </div>

                <div className='d-flex flex-column align-items-center justify-content-center gap-3'>
                  {/* Mostrar botão e mensagem APENAS quando houver erro no auto-save */}
                  {saveStatus === 'error' && (
                    <>
                      <div
                        className='alert alert-warning d-flex align-items-start px-4 py-3 mb-0'
                        style={{maxWidth: '400px'}}
                      >
                        <i className='bi bi-exclamation-triangle-fill me-3 fs-4 text-warning'></i>
                        <div className='text-start'>
                          <div className='fw-bold text-dark mb-1'>
                            Falha no salvamento automático
                          </div>
                          <div className='fs-7 text-muted'>
                            Ocorreu um erro ao salvar suas alterações. Por favor, clique no botão
                            abaixo para tentar salvar manualmente.
                          </div>
                        </div>
                      </div>

                      <button
                        type='button'
                        className='btn btn-primary btn-sm px-8'
                        data-kt-users-modal-action='submit'
                        onClick={submitForm}
                        disabled={formik.isSubmitting || !formik.values.project_id}
                      >
                        <span className='indicator-label'>
                          {intl.formatMessage({id: 'GENERAL.EDIT_TASK'})}
                        </span>

                        {formik.isSubmitting && (
                          <span className='indicator-progress'>
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </>
                  )}

                  {/* Indicadores discretos (quando NÃO há erro) */}
                  {saveStatus !== 'error' && (
                    <>
                      {saveStatus === 'saving' && (
                        <div className='d-flex align-items-center text-primary'>
                          <span className='spinner-border spinner-border-sm me-2'></span>
                          <span className='fs-7'>Salvando...</span>
                        </div>
                      )}

                      {saveStatus === 'saved' && (
                        <div
                          className='d-flex align-items-center text-success'
                          style={{
                            animation: 'fadeIn 0.3s ease-in',
                          }}
                        >
                          <i className='bi bi-check-circle-fill fs-4 me-1'></i>
                          <span className='fs-7 fw-bold'>Salvo</span>
                        </div>
                      )}
                    </>
                  )}
                </div>

                {!formik.values.project_id && saveStatus === 'error' && (
                  <div className='text-danger fs-7 mt-2'>Selecione um projeto para continuar</div>
                )}
              </div>
            </div>
          </div>
        </div>
        {(formik.isSubmitting || isTaskLoading) && <Loading />}
      </div>
      {/* 
      //@ts-ignore */}
      <AdjustTimeUserModal
        show={showAdjustTimeModal}
        handleClose={() => setShowAdjustTimeModal(false)}
        taskId={task?.tasks.id}
      />
      <DeliveryOptionsModal
        show={showDeliveryModal}
        onClose={() => setShowDeliveryModal(false)}
        onDeliverFull={() => deliveryItem.mutate()}
        onDeliverPartial={() => deliveryPartialItem.mutate()}
        taskName={task?.tasks?.name}
      />
      <CreateProjectAndClient
        show={showProjectAndClientModal}
        handleClose={() => setShowProjectAndClientModal(false)}
      />
    </>
  )
}

export {TaskEditModalForm}
